import React from 'react';
import { Modal, Button } from 'react-bulma-components';

const AdditionalConfirmationModal = ({ show, onConfirm, onCancel, selectedBookingsCount }) => {
    return (
        <Modal show={show} onClose={onCancel}>
            <Modal.Card>
                <Modal.Card.Header>
                    ATTENTION: Confirm Mass Deletion
                </Modal.Card.Header>
                <Modal.Card.Body>
                    <p>You are going to delete {selectedBookingsCount} admin bookings PERMANENTLY.</p>
                    <p> As you will not be able to undo this, please check your selection carefully!</p>
                    <p>Do you want to continue? (To alter your selection click on  &quot;No, Return&quot;)</p>

                </Modal.Card.Body>
                <Modal.Card.Footer>
                    <Button color="danger" onClick={onConfirm}>Yes, Continue</Button>
                    <Button onClick={onCancel}>No, Return</Button>
                </Modal.Card.Footer>
            </Modal.Card>
        </Modal>
    );
};

export default AdditionalConfirmationModal;
